import React, { useState, useRef } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "primereact/menu";
import "../assets/styles/Navbar.css";
import logo from "../assets/images/logixlog-w.png";

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);

  const servicesBtnRef = useRef(null);
  const menuRef = useRef(null);

  const navItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Services +", path: "/services" },
    { label: "Recent Projects", path: "/projects" },
    // { label: "Blog", path: "/blog" },
    { label: "Clients", path: "/clients" }
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    {
      label: "AI Development Services",
      command: () => navigate("/services/ai-development"),
    },
    {
      label: "Mobile App Development",
      command: () => navigate("/services/mobile-app-development"),
    },
    {
      label: "AI Chat Development",
      command: () => navigate("/services/ai-chat-development"),
    },
    {
      label: "Custom Software",
      command: () => navigate("/services/custom-software"),
    },
    {
      label: "Predictive Modeling",
      command: () => navigate("/services/predictive-modeling"),
    },
    {
      label: "Digital Marketing",
      command: () => navigate("/services/digital-marketing"),
    },
    {
      label: "Chat GPT Integrations",
      command: () => navigate("/services/chat-gpt-integrations"),
    },
    {
      label: "DevOps",
      command: () => navigate("/services/devops"),
    },
    {
      label: "Natural Language Processing",
      command: () => navigate("/services/natural-language-processing"),
    },
    {
      label: "Custom Web Development",
      command: () => navigate("/services/custom-web-development"),
    },
    {
      label: "Machine Learning",
      command: () => navigate("/services/machine-learning"),
    },
    {
      label: "UI UX Design",
      command: () => navigate("/services/ui-ux-design"),
    },
    {
      label: "Computer Vision",
      command: () => navigate("/services/computer-vision"),
    },
    {
      label: "Staff Augmentation",
      command: () => navigate("/services/staff-augmentation"),
    },
  ];

  // const projectMenuItems = [
  //   {
  //     label: "AgeWiser",
  //     command: () => navigate("/projects/agewiser"),
  //   },
  //   {
  //     label: "SafrCare",
  //     command: () => navigate("/projects/safrcare"),
  //   },
  //   {
  //     label: "Chronos",
  //     command: () => navigate("/projects/chronos"),
  //   },
  //   {
  //     label: "Doclinq",
  //     command: () => navigate("/projects/doclinq"),
  //   },
  //   {
  //     label: "Proctor8",
  //     command: () => navigate("/projects/proctor8"),
  //   },
  //   {
  //     label: "Interoads",
  //     command: () => navigate("/projects/interoads"),
  //   },
  //   {
  //     label: "NinjaHR",
  //     command: () => navigate("/projects/ninja-hr"),
  //   },
  //   {
  //     label: "Career VI",
  //     command: () => navigate("/projects/career-vi"),
  //   },
  // ];

  const handleMouseEnter = (e) => {
    if (servicesBtnRef.current && menuRef.current) {
      setMenuVisible(true);
      menuRef.current.show(e, servicesBtnRef.current);
    }
  };

  return (
    <AppBar position="static" className="navbar-container">
      <Toolbar>
        <Box className="logo-container">
          <Link to="/" style={{ textDecoration: "none" }}>
            <img src={logo} alt="Logo" className="logo-image" />
          </Link>
        </Box>

        {/* Desktop Navigation */}
        <Box className="nav-links" onMouseLeave={() => setMenuVisible(false)}>
          {navItems.map((item, index) => {
            const isServices = item.label === "Services +";

            return (
              <Box
                key={index}
                className={`nav-item ${isServices ? "dropdown-nav" : ""}`}
                onMouseEnter={isServices ? handleMouseEnter : undefined}
              >
                <Button
                  component={Link}
                  to={item.path}
                  target={item.target || ""}
                  className={`nav-link ${
                    location.pathname === item.path ? "active" : ""
                  }`}
                  ref={isServices ? servicesBtnRef : undefined}
                  onClick={() => {
                    if (isServices && menuRef.current) {
                      menuRef.current.hide();
                    }
                  }}
                >
                  {item.label}
                </Button>
                {location.pathname === item.path && (
                  <div className="active-indicator" />
                )}
              </Box>
            );
          })}

          <Button component={Link} to="/contact" className="contact-button">
            Contact Us
          </Button>
        </Box>

        <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          onClick={handleDrawerToggle}
          className="menu-button"
        >
          <MenuIcon sx={{ color: "black" }} />
        </IconButton>

        <Drawer
          anchor="right"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          className="drawer"
          sx={{
            zIndex: (theme) => theme.zIndex.modal + 100000,
          }}
        >
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={handleDrawerToggle}
            onKeyDown={handleDrawerToggle}
          >
            <List>
              {navItems.map((item, index) => (
                <ListItem key={index} disablePadding>
                  <ListItemButton component={Link} to={item.path}>
                    <ListItemText
                      primary={item.label}
                      className={
                        location.pathname === item.path ? "active" : ""
                      }
                    />
                  </ListItemButton>
                </ListItem>
              ))}
              <ListItem disablePadding>
                <ListItemButton component={Link} to="/contact">
                  <ListItemText
                    primary="Contact Us"
                    className="contact-button-text"
                  />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        </Drawer>
      </Toolbar>

      {/* Services Menu */}

      <Menu
        model={menuItems}
        popup
        ref={menuRef}
        onHide={() => setMenuVisible(false)}
        className="two-column-menu"
        style={{ width: "auto" }}
        onMouseEnter={() => setMenuVisible(true)} 
        onMouseLeave={(e) => {
          setMenuVisible(false);
          if (menuRef.current?.hide) {
            menuRef.current.hide({ currentTarget: servicesBtnRef.current });
          }
        }}
      />

      {/* Projects Menu */}
      {/* <Menu
        model={projectMenuItems}
        popup
        ref={projectsMenuRef}
        onHide={() => setProjectsMenuVisible(false)}
        className="two-column-menu-projects"
        style={{ width: "auto" }}
      /> */}
    </AppBar>
  );
};

export default Navbar;
